export const mesasEntradaConstants = {
  SAVE_FILTERS: "SAVE_FILTERS",
  ABOGADO_EXTRAJUDICIAL: "ABOGADO_EXTRAJUDICIAL",
  ABOGADO_JUDICIAL: "ABOGADO_JUDICIAL",
  MESA_EXTRAJUDICIAL: "MESA_EXTRAJUDICIAL",
  MESA_JUDICIAL: "MESA_JUDICIAL",
  LIMPIAR_MESAS: "LIMPIAR_MESAS",
  FECHA_INICIAL: "FECHA_INICIAL",
  MESA_EXTERNA: "MESA_EXTERNA",
};